module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAeCAYAAAAl+Z4RAAAABHNCSVQICAgIfAhkiAAAANdJREFUOE+l1cENgjAUxvH3IHp2E91A3UA38KI3EnQSRnATcQOcRM4S+UyJkJDS9r3S+/+Xpmn7+JLdKhDeTYrjvShqUi4+Z9eSmbcgVE2CvRbhU56vlt+kJKZ1DMJmx3OQDpiDDEAsMgJiEAvQIpOABnECUsQLSJAgEEJEgA8RAy5EBVgIUEYBi5YfTLwB8FQB5tH1MYFen7TdiYGp2PwdIsAVmzMJAr44CIRiLyCJnYA0ngQ0sQVo4xEQEw9AbNwBc+IO6Edbf7fVo+0/XOsmxUEbmx38AG4HK9OaDv1kAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/ico-arrowlarge.png
// module id = 479
// module chunks = 0